import { render, staticRenderFns } from "./AccidentIntakeWizard.vue?vue&type=template&id=01e2a08f&scoped=true"
import script from "./AccidentIntakeWizard.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeWizard.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeWizard.vue?vue&type=style&index=0&id=01e2a08f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e2a08f",
  null
  
)

export default component.exports